/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { affordabilityCalculatorAuthenticatedPostRequestSchema } from './affordabilityCalculatorAuthenticatedPostRequestSchema.ts';
import { affordabilityCalculatorAuthenticatedPostResponseSchema } from './affordabilityCalculatorAuthenticatedPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postAffordabilityCalculatorAuthenticated200Schema = z.lazy(
  () => affordabilityCalculatorAuthenticatedPostResponseSchema
);

/**
 * @description 505 response
 */
export const postAffordabilityCalculatorAuthenticated505Schema = z.any();

export const postAffordabilityCalculatorAuthenticatedMutationRequestSchema = z.lazy(
  () => affordabilityCalculatorAuthenticatedPostRequestSchema
);

export const postAffordabilityCalculatorAuthenticatedMutationResponseSchema = z.lazy(
  () => postAffordabilityCalculatorAuthenticated200Schema
);
